module.exports = __webpack_public_path__ + "img/comment-arrow-up-right.7695b554.svg";